import { Link } from 'react-router-dom';

import pt from '../../locales/pt';
import { paths } from '../../routes/paths';
import { cn } from '../../utils/cn';
import { formatEUR } from '../../utils/money';
import { allocationDotClass } from '../../utils/quickCreateAllocation';
import { formatGoalTargetMonth, isChecklistGoal } from '../../utils/goalDisplayUtils';
import { GoalAllocationTag } from './GoalAllocationTag';
import { GoalVisionImage, VISION_SCRIM_CLASS } from './GoalVisionImage';

const TONE_BAND = 'bg-gradient-to-r from-sage-500 to-sage-600';

/** ds/tile/goal-vision no .pen — objetivo secundário no mosaico do vision board. */
export function GoalMosaicTile({ goal, className }) {
  const isChecklist = isChecklistGoal(goal);
  const target = Number(goal.target_amount || 0);
  const accumulated = Number(goal.accumulated || 0);
  const pct = Math.min(100, Math.max(0, Number(goal.progress_pct || 0)));
  const completedCount = goal.checklist_completed_count ?? 0;
  const totalCount = goal.checklist_total_count ?? 0;
  const targetMonth = formatGoalTargetMonth(goal.target_date);

  return (
    <Link
      to={paths.goal(goal.id)}
      className={cn(
        'block overflow-hidden rounded-ds-lg border border-border bg-card shadow-sm transition-shadow hover:shadow-md',
        className,
      )}
    >
      <div className="relative flex h-[104px] flex-col justify-between gap-space-2 p-space-3">
        <GoalVisionImage
          imageUrl={goal.image_url}
          alt={goal.name}
          groupClassName={allocationDotClass(goal.budget_allocation)}
          className="absolute inset-0"
        />
        <div className={VISION_SCRIM_CLASS} />

        <div className="relative flex justify-end">
          {targetMonth ? (
            <span className="inline-flex items-center rounded-ds-full bg-on-hero-track px-space-2 py-space-1 type-chip text-on-hero">
              {targetMonth}
            </span>
          ) : null}
        </div>

        <div className="relative">
          <GoalAllocationTag allocation={goal.budget_allocation} />
        </div>
      </div>

      <div className="flex flex-col gap-space-2 p-space-4">
        <p className="type-title-card truncate text-card-foreground" title={goal.name}>
          {goal.name}
        </p>

        <div className="h-1.5 w-full overflow-hidden rounded-full bg-track">
          <div className={cn('h-full rounded-full', TONE_BAND)} style={{ width: `${pct}%` }} />
        </div>

        <div className="flex items-center justify-between gap-space-2">
          <p className="type-chip text-muted-foreground">
            {isChecklist
              ? pt.goals.vision.checklistSteps
                  .replace('{done}', String(completedCount))
                  .replace('{total}', String(totalCount))
              : `${formatEUR(accumulated)} de ${formatEUR(target)}`}
          </p>
          <p className="font-display text-type-chip font-bold text-sage-on-tint">
            {Math.round(pct)} %
          </p>
        </div>
      </div>
    </Link>
  );
}
